<!-- 我的游戏币 游戏币 -->
<template>
<el-dialog
    class="ball-style"
    :visible.sync="status"
    :append-to-body="true"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :show-close="false"
    >
    <div class="ball-cup-container">
        <div class="close" @click="closeHandler"><img :src="require('../assets/close.png')" width="32" alt=""></div>
        
        <div class="title-text ">
            <div class="main"><img :src="require('../assets/my-gold-text.png')" height="24" alt=""></div>

        </div>
        <div class="cont-row mrg-btm25">
            <div class="flex-cont cont-row">
                <img :src="require('../assets/gold-2.png')" height="26" alt="">
                <div class="my-gold-count">{{user.gold}}</div>
            </div>
            <!-- <div class="recharge">立即充值</div> -->
        </div>
        <ul class="list">
            <li v-for="item in list" :key="item.id">
                <div class="tag"><img :src="require('../assets/xunzhang.png')" alt=""></div>
                <div class="flex-cont">
                    <div class="cont-row">
                        <div class="flex-cont result">{{item.title}}</div>
                        <div class="cont integral win" v-if="item.delta>0">+{{item.delta}}</div>
                        <div class="cont integral default" v-if="item.delta <0">{{item.delta}}</div>
                    </div>
                    <!-- <div class="desc win ">{{item.time|  torontoTimeFormat('MM-DD')}}{{item.team1}} VS {{item.team2}}</div> -->
                    <!-- <div class="desc win">{{item.content}}</div> -->
                    <div class="cont-row desc">
                        <div class="flex-cont">{{item.content}}</div>
                        <div class="cont">余额：{{item.balance}}</div>
                    </div>
                </div>
            </li>
            <li v-if="list.length==0" class="nodata">暂无相关数据</li>
            <!-- <li>
                <div class="tag"><img :src="require('../assets/xunzhang.png')" alt=""></div>
                <div class="flex-cont">
                    <div class="cont-row">
                        <div class="flex-cont result">竞猜胜利</div>
                        <div class="cont integral win">+100</div>
                    </div>
                    <div class="desc win ">11月21日法国 VS 澳大利亚</div>
                </div>
            </li>
            <li>
                <div class="tag"><img :src="require('../assets/xunzhang.png')" alt=""></div>
                <div class="flex-cont">
                    <div class="cont-row">
                        <div class="flex-cont result">竞猜胜利</div>
                        <div class="cont integral default">-200</div>
                    </div>
                    <div class="desc ">11月21日法国 VS 澳大利亚</div>
                </div>
            </li> -->
        </ul>
    </div>
</el-dialog>
</template>
<script>
export default {
    name :'MyGold',
    props:['status'],
    computed:{
        user(){
            return this.$store.getters.user;
        }
    },
    data(){
        return {
            pageLoading:false,
            list:[]
        }
    },
    methods:{
        closeHandler(){
            this.$emit('update:status',false)
        },
        async getFlow(){
            this.pageLoading = true;
            let result = await this.$axios.get('/worldcup2022/gold/coin/my/flow/list');
            this.pageLoading = false;
            console.log(result)
            if( result.code == 0){
                this.list = result.data.flows||[];
            }
        }
    },
    watch:{
        status(val){
            if( val ) {
                this.getFlow()
            }
        }
    }
}
</script>
<style lang="less" scoped>
.ball-style{
    /deep/.el-dialog{width:380px; background: none;}
    /deep/.el-dialog__header{display: none;}
    /deep/.el-dialog__body{
        padding: 0;
    }
}
@media screen and (max-width:768px){
    .ball-style{

        /deep/.el-dialog{width:90%}
    }
}

.ball-cup-container{
    background: url(../assets/guessing-gold-bg1.png) no-repeat right top #ff4400; padding:15px; position: relative; border-radius: 10px;
    .title-text{
        display: flex; align-items: center; padding: 5px 0 25px; 
        
    }
    .mrg-btm25{margin-bottom: 25px;}
    .recharge{font-size: 14px; line-height: 32px; border: 1px solid rgba(90,90,90,0.6); border-radius: 17px; padding: 0 15px; user-select: none; cursor: pointer;} 
    .win-cup{position: absolute; right: 70px; top: -31px;}
    .my-gold-count{font-size: 30px; line-height: 30px; color: #111; font-weight: 600; margin-left: 5px;}
    .close{position: absolute; right: 25px; top: 15px; cursor: pointer;}
}

.list{
    padding:30px 12px 10px; background: #fff; border-radius: 10px; max-height: 480px; overflow-y:auto;
    li{
        display: flex; align-items: flex-start; padding-bottom: 12px; margin-bottom: 15px; border-bottom: 1px solid #eee;
        .tag{margin-right: 15px;}
        .result{font-size: 16px; line-height: 24px; font-weight: 600; color: #333;}
        .integral{
            font-size: 14px; line-height: 20px; font-weight: 500;
            &.win{color: #FF5108;}
            &.default{color: #00AA5E;}
        }
        .desc{font-size: 12px; line-height: 18px; color: #999;}
        &.nodata{text-align: center; color: #999; justify-content: center;}
    }
}
</style>